import React, { useContext, useEffect, useState } from 'react'
import { FormContext } from '../../context/form/FormContext';
import QuestionName from '../styleComponents/QuestionName';

const SingleChoice = ({ id, question, qDescription, answers, answer, page, setPage, limitPage  }) => {
    const { handleChange } = useContext(FormContext)

    const [step,setStep] = useState(0)

    const general =  (id, event, numero) => {

      handleChange(id,event)
      if(page === limitPage){
        console.log('fin')
      }else if (numero){
          setStep(numero + 1)
      }else {
          setStep(1)
        }
      }


    useEffect(() => {
      if(step > 1){
        setPage(step)
      }else {
        setPage(step + page)
      }  
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [step])
    
    return (
        <>
         <QuestionName questionName={question} description={qDescription}/>
         <div className='questionContainer'>         

          {answers.length > 0 && answers.map((radio, i) =>
          
          <div 
            onClick={() =>general(id, { target: { value: radio.label }}, radio.jumpTo)}
            className={`form-check single_choice ${answer === radio.label ? 'single_choice-active' : 'single_choice-inactive'}`} 
            key={i}
          >
           <input
              onChange={(event) =>general(id,event, radio.jumpTo)}
              className="form-check-input single-choice-input"
              type="radio"
              name={`${i}-${id}`}
              id={`${i}-${id}`}
              key={`${i}-${id}`}
              value={radio.label}
              checked={answer === radio.label}
              />
            <label className="form-check-label" htmlFor={i}>{radio.label}</label>
          </div>
          )}
                    </div>

        </>
    )
}

export default SingleChoice
